<template>
  <svg viewBox="0 0 392.598 392.598">
    <rect
      x="82.295"
      y="21.786"
      style="fill:#FFFFFF;"
      width="228.202"
      height="348.962"
    />
    <path
      style="fill:#194F82;"
      d="M321.357,0H71.305c-6.012,0-10.925,4.848-10.925,10.925v370.747c0,6.012,4.848,10.925,10.925,10.925
      h249.988c6.012,0,10.925-4.848,10.925-10.925V10.861C332.283,4.848,327.369,0,321.357,0z M310.367,370.747H82.295V21.786h228.202
      v348.962L310.367,370.747L310.367,370.747z"
    />
    <path
      style="fill:#56ACE0;"
      d="M277.721,43.572h-162.78c-6.012,0-10.925,4.848-10.925,10.925v218.117h36.331
      c5.43,0,10.408,3.685,11.378,9.051c1.099,6.788-4.073,12.735-10.731,12.735h-36.848v21.786h24.76c5.43,0,10.408,3.685,11.378,9.051
      c1.099,6.788-4.073,12.735-10.731,12.735H104.21v10.925h184.501v-294.4C288.582,48.549,283.733,43.572,277.721,43.572z"
    />
    <g>
      <rect
        x="125.866"
        y="65.422"
        style="fill:#FFC10D;"
        width="140.929"
        height="36.008"
      />
      <rect
        x="125.866"
        y="123.152"
        style="fill:#FFC10D;"
        width="140.929"
        height="36.008"
      />
    </g>
    <path
      style="fill:#194F82;"
      d="M277.721,43.572h-162.78c-6.012,0-10.925,4.848-10.925,10.925v57.794v57.794
      c0,6.012,4.848,10.925,10.925,10.925h162.715c6.012,0,10.925-4.848,10.925-10.925v-57.794V54.562
      C288.582,48.549,283.733,43.572,277.721,43.572z M266.796,159.16H125.866v-36.008h140.929V159.16z M266.796,101.366H125.866V65.422
      h140.929V101.366z"
    />
    <path
      style="fill:#FFC10D;"
      d="M196.331,253.349c-10.667,0-19.329,8.663-19.329,19.329c0,10.667,8.663,19.329,19.329,19.329
      c10.667,0,19.329-8.663,19.329-19.329C215.66,262.012,206.998,253.349,196.331,253.349z"
    />
    <path
      style="fill:#194F82;"
      d="M196.331,231.564c-22.691,0-41.18,18.489-41.18,41.18s18.489,41.18,41.18,41.18
      s41.18-18.489,41.18-41.18C237.511,249.988,219.022,231.564,196.331,231.564z M196.331,292.008
      c-10.667,0-19.329-8.663-19.329-19.329c0-10.667,8.663-19.329,19.329-19.329c10.667,0,19.329,8.663,19.329,19.329
      C215.66,283.345,206.998,292.008,196.331,292.008z"
    />
  </svg>
</template>
